'use strict';

//dependencies included for running in node
if (typeof exports !== 'undefined') {
	if (typeof module !== 'undefined' && module.exports) {
		var AnnuityTable = require('../tables/annuityTable');
		var Gender = require('../lib/gender');
	}
}

var Annuity = function(annuities) {
	this.annuityTable = new AnnuityTable(annuities);
};

Annuity.prototype.rate = function(gender, yearOfBirth, retirementAge, options) {

	//this is typically an annuity pair: [base rate, 100% spouse adjustment]
	var annuity = this.annuityTable.getRate(gender, yearOfBirth, retirementAge, options);
	var base = annuity[0];
	var jointLifeAdjustment = annuity[1];

	if(options && options.spousePension) {
		base = base + (jointLifeAdjustment * options.spousePension);
	}

	return base;
};

Annuity.prototype.expense = function() {
	return this.annuityTable.getExpense();
};

//return minimum effective retirement age supported by the model as determined by available annuity rates
// allows for inconsistant length in annuity rate tables
Annuity.prototype.minimumAge = function() {
	var getMinimumAge = function(rates) {
		var startAge = Number.NEGATIVE_INFINITY;
		for(var i in rates) {
			if(rates.hasOwnProperty(i)) {
				for (var j in rates[i]) {
					if(rates[i].hasOwnProperty(j) && typeof rates[i][j].startAge == 'number' && rates[i][j].startAge > startAge) {
						startAge = rates[i][j].startAge;
					}
				}				
			}

		}
		return startAge;
	};

	return Math.max(getMinimumAge(this.annuityTable.rates(Gender.MALE)), getMinimumAge(this.annuityTable.rates(Gender.FEMALE)));
};

//return maximum effective retirement age supported by the model as determined by availablea annuity rates
// allows for inconsistant length in annuity rate tables
Annuity.prototype.maximumAge = function() {
	var getMaximumAge = function(rates) {
		var endAge = Number.POSITIVE_INFINITY;
		for(var i in rates) {
			if(rates.hasOwnProperty(i)) {
				for(var j in rates[i]) {
					if(rates[i].hasOwnProperty(j) && typeof rates[i][j].rates == 'object') {
						//NOTE: assumes all birth years contain the same number of rates
						var length = rates[i][j].rates[Object.keys(rates[i][j].rates)[0]].length - 1;
					
						if(rates[i][j].startAge + length < endAge) {
							endAge = rates[i][j].startAge + length;
						}
					}
				}
			}
		}
		return endAge;
	};
	
	return Math.min(getMaximumAge(this.annuityTable.rates(Gender.MALE)), getMaximumAge(this.annuityTable.rates(Gender.FEMALE)));
};

//Node module export
if (typeof exports !== 'undefined') {
    if (typeof module !== 'undefined' && module.exports) {
        exports = module.exports = Annuity;
    }
    exports.Annuity = Annuity;
}
